module.exports = __webpack_public_path__ + "static/media/ico_informacao.1688ae7a.svg";